(function () {
  var STORAGE_KEY = 'brixton:compare';
  var MODE_KEY = 'brixton:compareMode';

  function getStore() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function setStore(store) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    } catch (e) {}
  }

  function getMode() {
    try {
      return sessionStorage.getItem(MODE_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setMode(on) {
    try {
      sessionStorage.setItem(MODE_KEY, on ? '1' : '0');
    } catch (e) {}
  }

  function getContainers() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-compare-container]'));
  }

  function getMaxItems() {
    var container = document.querySelector('[data-compare-container]');
    if (!container) return 4;
    var max = parseInt(container.getAttribute('data-compare-max'), 10);
    return isNaN(max) ? 4 : max;
  }

  var cachedFieldDefs = null;
  function getFieldDefs() {
    if (cachedFieldDefs) return cachedFieldDefs;
    var tray = document.querySelector('[data-compare-tray]');
    if (!tray) return [];
    try {
      cachedFieldDefs = JSON.parse(tray.getAttribute('data-compare-fields') || '[]');
    } catch (e) {
      cachedFieldDefs = [];
    }
    return cachedFieldDefs;
  }

  // --- First-time hint ------------------------------------------------
  // Shown once, ever, the first time someone turns compare mode on.
  // Dismissed by: closing it, making a selection, or exiting compare mode.
  var HINT_SEEN_KEY = 'brixton:compareHintSeen';

  function hasSeenHint() {
    try {
      return localStorage.getItem(HINT_SEEN_KEY) === '1';
    } catch (e) {
      return true;
    }
  }

  function markHintSeen() {
    try {
      localStorage.setItem(HINT_SEEN_KEY, '1');
    } catch (e) {}
  }

  function removeHint() {
    var hint = document.querySelector('[data-compare-hint]');
    if (hint) hint.remove();
    markHintSeen();
  }

  function showHintIfNeeded() {
    if (hasSeenHint()) return;
    if (document.querySelector('[data-compare-hint]')) return;

    var toggleBtn = document.querySelector('[data-toggle-compare]');
    if (!toggleBtn) return;

    var max = getMaxItems();
    var hint = document.createElement('span');
    hint.className = 'compare-hint';
    hint.setAttribute('data-compare-hint', '');
    hint.innerHTML =
      'Select up to ' + max + ' to compare' +
      '<button type="button" class="compare-hint__close" data-compare-hint-close aria-label="Dismiss">&times;</button>';
    toggleBtn.insertAdjacentElement('afterend', hint);
  }

  // --- First-time onboarding tooltip ---------------------------------------
  var TOOLTIP_SEEN_KEY = 'brixton:compareTooltipSeen';
  var activeTooltip = null;

  function hasSeenTooltip() {
    try {
      return localStorage.getItem(TOOLTIP_SEEN_KEY) === '1';
    } catch (e) {
      return true; // if storage is unavailable, fail safe by not showing it
    }
  }

  function markTooltipSeen() {
    try {
      localStorage.setItem(TOOLTIP_SEEN_KEY, '1');
    } catch (e) {}
  }

  function positionTooltip() {
    if (!activeTooltip || !activeTooltip._target) return;
    var rect = activeTooltip._target.getBoundingClientRect();
    activeTooltip.style.top = rect.bottom + window.scrollY + 8 + 'px';
    activeTooltip.style.left = rect.left + window.scrollX + 'px';
  }

  function dismissTooltipOnOutsideClick(e) {
    if (activeTooltip && !activeTooltip.contains(e.target)) {
      removeTooltip();
    }
  }

  function removeTooltip() {
    if (!activeTooltip) return;
    if (activeTooltip._target) {
      activeTooltip._target.classList.remove('compare-toggle--highlighted');
    }
    activeTooltip.remove();
    activeTooltip = null;
    document.removeEventListener('click', dismissTooltipOnOutsideClick, true);
    window.removeEventListener('resize', positionTooltip);
    window.removeEventListener('scroll', positionTooltip, true);
  }

  function showCompareOnboardingTooltip() {
    if (hasSeenTooltip()) return;

    var firstToggle = document.querySelector('[data-compare-mode] .compare-toggle');
    if (!firstToggle) return;

    markTooltipSeen();

    var max = getMaxItems();
    var tooltip = document.createElement('div');
    tooltip.className = 'compare-onboarding-tip';
    tooltip.innerHTML =
      '<span>Select up to ' + max + ' items to compare</span>' +
      '<button type="button" class="compare-onboarding-tip__close" aria-label="Dismiss">&times;</button>';

    document.body.appendChild(tooltip);
    activeTooltip = tooltip;
    activeTooltip._target = firstToggle;

    firstToggle.classList.add('compare-toggle--highlighted');
    positionTooltip();

    window.addEventListener('resize', positionTooltip);
    window.addEventListener('scroll', positionTooltip, true);
    document.addEventListener('click', dismissTooltipOnOutsideClick, true);

    tooltip.querySelector('.compare-onboarding-tip__close').addEventListener('click', function (e) {
      e.stopPropagation();
      removeTooltip();
    });

    setTimeout(removeTooltip, 6000);
  }

  function escapeHtml(str) {
    if (str === null || str === undefined) return '';
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function applyMode() {
    var on = getMode();

    getContainers().forEach(function (container) {
      if (on) {
        container.setAttribute('data-compare-mode', '');
      } else {
        container.removeAttribute('data-compare-mode');
      }
    });

    var toggleBtns = document.querySelectorAll('[data-toggle-compare]');
    for (var i = 0; i < toggleBtns.length; i++) {
      var btn = toggleBtns[i];
      var label = btn.querySelector('[data-compare-toggle-label]');
      if (label) {
        var enterLabel = label.getAttribute('data-enter-label') || label.textContent;
        var exitLabel = label.getAttribute('data-exit-label') || 'Exit compare';
        if (!label.getAttribute('data-enter-label')) {
          label.setAttribute('data-enter-label', enterLabel);
        }
        label.textContent = on ? exitLabel : label.getAttribute('data-enter-label');
      }
      if (btn.classList) {
        btn.classList.toggle('toggle-btn--active', on);
      }
    }
  }

  function restoreCheckedState() {
    var store = getStore();
    var items = document.querySelectorAll('[data-compare-item]');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var id = item.getAttribute('data-product-id');
      var input = item.querySelector('.compare-toggle__input');
      if (input) {
        input.checked = !!store[id];
      }
    }
  }

  function updateTray() {
    var store = getStore();
    var ids = Object.keys(store);
    var tray = document.querySelector('[data-compare-tray]');
    if (!tray) return;

    if (getMode() && ids.length >= 1) {
      tray.setAttribute('data-visible', '');
    } else {
      tray.removeAttribute('data-visible');
    }

    var countEl = tray.querySelector('[data-compare-count]');
    if (countEl) {
      countEl.textContent = ids.length + (ids.length === 1 ? ' item selected' : ' items selected');
    }

    var compareBtn = tray.querySelector('[data-compare-open]');
    if (compareBtn) {
      compareBtn.disabled = ids.length < 2;
    }
  }

  function addItem(id, payload) {
    var store = getStore();
    var max = getMaxItems();
    var currentCount = Object.keys(store).length;
    if (!store[id] && currentCount >= max) {
      return false;
    }
    store[id] = payload;
    setStore(store);
    return true;
  }

  function removeItem(id) {
    var store = getStore();
    delete store[id];
    setStore(store);
  }

  function clearAll() {
    setStore({});
    restoreCheckedState();
    updateTray();
    closeDrawer();
  }

  function showLimitMessage() {
    var tray = document.querySelector('[data-compare-tray]');
    if (!tray) return;
    var msgEl = tray.querySelector('[data-compare-count]');
    if (!msgEl) return;
    var max = getMaxItems();
    msgEl.textContent = 'You can compare up to ' + max + ' items';
    setTimeout(updateTray, 2200);
  }

  function handleCheckboxChange(e) {
    var input = e.target;
    if (!input.matches || !input.matches('.compare-toggle__input')) return;

    var item = input.closest('[data-compare-item]');
    if (!item) return;

    var id = item.getAttribute('data-product-id');
    var payloadRaw = item.getAttribute('data-compare-payload');
    var payload = {};
    try {
      payload = JSON.parse(payloadRaw);
    } catch (err) {}

    if (input.checked) {
      var added = addItem(id, payload);
      if (!added) {
        input.checked = false;
        showLimitMessage();
        return;
      }
      removeHint();
    } else {
      removeItem(id);
    }

    updateTray();
  }

  // Selected variant id per product, tracked only while the drawer is open (not persisted).
  var selectedVariants = {};

  function findVariant(product, variantId) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return variants[0];
  }

  function buildTable() {
    var store = getStore();
    var ids = Object.keys(store);
    var items = ids.map(function (id) {
      return store[id];
    });

    var drawer = document.querySelector('[data-compare-drawer]');
    if (!drawer) return;
    var content = drawer.querySelector('[data-compare-content]');
    if (!content) return;

    if (items.length < 2) {
      content.innerHTML = '<p class="compare-drawer__empty">Select at least 2 products to compare.</p>';
      return;
    }

    // Reset variant selection each time the table is (re)built, defaulting to
    // the first available variant per product.
    selectedVariants = {};
    items.forEach(function (p) {
      var variants = p.variants || [];
      var defaultVariant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) {
          defaultVariant = variants[i];
          break;
        }
      }
      if (!defaultVariant) defaultVariant = variants[0];
      selectedVariants[p.id] = defaultVariant ? defaultVariant.id : null;
    });

    var fields = getFieldDefs();

    var headerCells = items
      .map(function (p) {
        var img = p.image ? '<img src="' + p.image + '" alt="" width="64" height="64" loading="lazy">' : '';
        var titleParts = p.title.split(' - ');
        var titleMain = escapeHtml(titleParts[0]);
        var titleSub = titleParts.length > 1 ? escapeHtml(titleParts.slice(1).join(' - ')) : '';
        var titleHtml = titleSub ? titleMain + '<br><span class="compare-table__product-subtitle">' + titleSub + '</span>' : titleMain;
        var titleText = escapeHtml(p.title.replace(' - ', ' '));
        return (
          '<td class="compare-table__product">' +
          '<a href="' + p.url + '">' +
          img +
          '<span>' + titleHtml + '</span>' +
          '</a>' +
          '<button type="button" class="compare-table__remove" data-compare-remove="' + p.id + '" aria-label="Remove ' + titleText + ' from compare">&times;</button>' +
          '</td>'
        );
      })
      .join('');

    var variantCells = items
      .map(function (p) {
        var variants = p.variants || [];
        if (variants.length <= 1) {
          var only = variants[0];
          return '<td>' + (only ? escapeHtml(only.title) : '\u2014') + '</td>';
        }
        var options = variants
          .map(function (v) {
            var disabled = v.available ? '' : ' disabled';
            var selected = String(v.id) === String(selectedVariants[p.id]) ? ' selected' : '';
            var label = escapeHtml(v.title) + (v.available ? '' : ' (sold out)');
            return '<option value="' + v.id + '"' + disabled + selected + '>' + label + '</option>';
          })
          .join('');
        return (
          '<td><select class="compare-variant-select" data-compare-variant-select data-product-id="' +
          p.id +
          '">' +
          options +
          '</select></td>'
        );
      })
      .join('');

    var priceCells = items
      .map(function (p) {
        var variant = findVariant(p, selectedVariants[p.id]);
        return (
          '<td class="compare-table__price" data-compare-price="' +
          p.id +
          '">' +
          (variant ? escapeHtml(variant.price) : '\u2014') +
          '</td>'
        );
      })
      .join('');

    var rows = fields
      .map(function (field) {
        var cellValues = items.map(function (p) {
          return p.fields && p.fields[field.id];
        });
        var allBlank = cellValues.every(function (v) {
          return v === null || v === undefined || v === '';
        });
        if (allBlank) return '';
        var cells = cellValues
          .map(function (v) {
            return '<td>' + (v ? escapeHtml(v) : '\u2014') + '</td>';
          })
          .join('');
        return '<tr><th scope="row">' + escapeHtml(field.label) + '</th>' + cells + '</tr>';
      })
      .join('');

    var cartCells = items
      .map(function (p) {
        var variant = findVariant(p, selectedVariants[p.id]);
        var disabled = !variant || !variant.available ? ' disabled' : '';
        return (
          '<td><button type="button" class="btn btn--primary compare-table__add-to-cart" data-compare-add-to-cart data-product-id="' +
          p.id +
          '"' +
          disabled +
          '>Add to cart</button></td>'
        );
      })
      .join('');

    content.innerHTML =
      '<div class="compare-table-wrap">' +
      '<table class="compare-table">' +
      '<thead><tr><th></th>' + headerCells + '</tr></thead>' +
      '<tbody>' +
      '<tr class="compare-table__variant-row"><th scope="row">Size</th>' + variantCells + '</tr>' +
      '<tr class="compare-table__price-row"><th scope="row">Price</th>' + priceCells + '</tr>' +
      rows +
      '</tbody>' +
      '<tfoot><tr><th></th>' + cartCells + '</tr></tfoot>' +
      '</table>' +
      '</div>';
  }

  function handleVariantSelectChange(e) {
    var select = e.target;
    if (!select.matches || !select.matches('[data-compare-variant-select]')) return;

    var productId = select.getAttribute('data-product-id');
    var variantId = select.value;
    selectedVariants[productId] = variantId;

    var store = getStore();
    var product = store[productId];
    if (!product) return;
    var variant = findVariant(product, variantId);

    var priceCell = document.querySelector('[data-compare-price="' + productId + '"]');
    if (priceCell) {
      priceCell.textContent = variant ? variant.price : '\u2014';
    }

    var cartBtn = document.querySelector('[data-compare-add-to-cart][data-product-id="' + productId + '"]');
    if (cartBtn) {
      cartBtn.disabled = !variant || !variant.available;
    }
  }

  // --- Cart drawer integration -------------------------------------------
  // Wired directly to CartDrawer (cart-drawer.js), which listens for these
  // document-level events:
  //   'dispatch:cart-drawer:refresh' -> re-fetches and swaps the drawer's
  //                                      <cart-form> contents
  //   'dispatch:cart-drawer:open'    -> opens the drawer; detail.opener is
  //                                      passed through for focus-return

  function dispatchCartDrawerEvent(name, detail) {
    document.dispatchEvent(new CustomEvent(name, detail ? { detail: detail } : undefined));
  }

  function updateCartCountBubble(count) {
    // The drawer's own refresh handles its internal contents; this covers
    // any header cart-count bubble that lives outside the drawer and isn't
    // touched by 'on:cart:after-merge'. Safe no-op if no such element exists.
    var bubbles = document.querySelectorAll('[data-cart-count], .cart-count, [data-cart-item-count]');
    for (var i = 0; i < bubbles.length; i++) {
      bubbles[i].textContent = count;
    }
  }

  function refreshCartState() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        updateCartCountBubble(cart.item_count);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function addToCart(variantId, buttonEl) {
    if (!variantId || !buttonEl) return;
    var originalText = buttonEl.textContent;
    buttonEl.disabled = true;
    buttonEl.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        buttonEl.textContent = 'Added';
        refreshCartState();
        dispatchCartDrawerEvent('dispatch:cart-drawer:refresh');
        dispatchCartDrawerEvent('dispatch:cart-drawer:open', { opener: buttonEl });
        closeDrawer();
        setTimeout(function () {
          buttonEl.textContent = originalText;
          buttonEl.disabled = false;
        }, 1800);
      })
      .catch(function () {
        buttonEl.textContent = 'Error \u2014 try again';
        setTimeout(function () {
          buttonEl.textContent = originalText;
          buttonEl.disabled = false;
        }, 2200);
      });
  }

  function handleAddToCartClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-compare-add-to-cart]') : null;
    if (!btn || btn.disabled) return;
    var productId = btn.getAttribute('data-product-id');
    var variantId = selectedVariants[productId];
    addToCart(variantId, btn);
  }

  function openDrawer() {
    buildTable();
    var drawer = document.querySelector('[data-compare-drawer]');
    if (drawer) {
      drawer.setAttribute('data-open', '');
      drawer.setAttribute('aria-hidden', 'false');
    }
    document.body.classList.add('compare-drawer-open');
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-compare-drawer]');
    if (drawer) {
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('compare-drawer-open');
  }

  function handleRemoveClick(e) {
    var btn = e.target.closest ? e.target.closest('[data-compare-remove]') : null;
    if (!btn) return;

    var id = btn.getAttribute('data-compare-remove');
    removeItem(id);
    restoreCheckedState();
    updateTray();
    buildTable();

    var store = getStore();
    if (Object.keys(store).length < 2) {
      closeDrawer();
    }
  }

  function init() {
    applyMode();
    restoreCheckedState();
    updateTray();
    if (getMode()) {
      showHintIfNeeded();
    }

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest ? e.target.closest('[data-toggle-compare]') : null;
      if (toggleBtn) {
        e.preventDefault();
        setMode(!getMode());
        applyMode();
        updateTray();
        if (getMode()) {
          showHintIfNeeded();
        } else {
          removeHint();
        }
        return;
      }

      var openBtn = e.target.closest ? e.target.closest('[data-compare-open]') : null;
      if (openBtn && !openBtn.disabled) {
        e.preventDefault();
        openDrawer();
        return;
      }

      var closeBtn = e.target.closest ? e.target.closest('[data-compare-close]') : null;
      if (closeBtn) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var hintCloseBtn = e.target.closest ? e.target.closest('[data-compare-hint-close]') : null;
      if (hintCloseBtn) {
        e.preventDefault();
        removeHint();
        return;
      }

      var clearBtn = e.target.closest ? e.target.closest('[data-compare-clear]') : null;
      if (clearBtn) {
        e.preventDefault();
        clearAll();
        return;
      }

      var cartBtn = e.target.closest ? e.target.closest('[data-compare-add-to-cart]') : null;
      if (cartBtn) {
        e.preventDefault();
        handleAddToCartClick(e);
        return;
      }

      handleRemoveClick(e);
    });

    document.addEventListener('change', function (e) {
      handleCheckboxChange(e);
      handleVariantSelectChange(e);
    });

    var observeTargets = document.querySelectorAll('[data-ajax-container]');
    if (observeTargets.length && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        restoreCheckedState();
      });
      for (var i = 0; i < observeTargets.length; i++) {
        observer.observe(observeTargets[i], { childList: true, subtree: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();